import React from 'react'

interface LineWobbleProps {
  size?: string
  speed?: string
  color?: string
  lineWeight?: string
}

export const LineWobble: React.FC<LineWobbleProps> = ({
  size = '80px',
  speed = '1.55s',
  color = 'black',
  lineWeight = '5px'
}) => {
  return (
    <div
      className='relative flex items-center justify-center overflow-hidden'
      style={{
        height: lineWeight,
        width: size,
        borderRadius: `calc(${lineWeight} / 2)`,
        transform: 'translate3d(0, 0, 0)'
      }}
    >
      <div className='absolute inset-0 opacity-10' style={{ backgroundColor: color }}></div>
      <div
        className='h-full w-full animate-wobble'
        style={
          {
            borderRadius: `calc(${lineWeight} / 2)`,
            backgroundColor: color,
            '--uib-speed': speed
          } as React.CSSProperties
        }
      ></div>
    </div>
  )
}
